document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-kilo-product]').forEach((productRoot) => {
    const productJsonEl = productRoot.querySelector('[data-kilo-product-json]');
    if (!productJsonEl) return;

    let product;
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch (error) {
      console.error('Could not parse product JSON', error);
      return;
    }

    const variantIdInput = productRoot.querySelector('[data-kilo-variant-id]');
    const selectedText = productRoot.querySelector('[data-kilo-selected-text]');
    const selectedWrapper = productRoot.querySelector('[data-kilo-selected-wrapper]');
    const priceText = productRoot.querySelector('[data-kilo-price]');
    const dotEl = productRoot.querySelector('[data-kilo-dot]');
    const submitButton = productRoot.querySelector('[data-kilo-submit]');
    const toggleButtons = productRoot.querySelectorAll('[data-kilo-toggle]');
    const moneyFormat = productRoot.dataset.moneyFormat || '${{amount}}';

    const hasAmount = productRoot.dataset.hasAmount === 'true';
const hasColor = productRoot.dataset.hasColor === 'true';
const hasSize = productRoot.dataset.hasSize === 'true';

const amountIndex = productRoot.dataset.amountIndex !== '' ? Number(productRoot.dataset.amountIndex) : null;
const colorIndex = productRoot.dataset.colorIndex !== '' ? Number(productRoot.dataset.colorIndex) : null;
const sizeIndex = productRoot.dataset.sizeIndex !== '' ? Number(productRoot.dataset.sizeIndex) : null;

    function formatMoney(cents) {
      const value = (cents / 100).toFixed(2);
      return moneyFormat.replace('{{amount}}', value);
    }

    function getSelectedOptions() {
      return product.options.map((optionName) => {
        const input = productRoot.querySelector(`[name="options[${CSS.escape(optionName)}]"]:checked`);
        return input ? input.value : null;
      });
    }

    function findVariant() {
      const selectedOptions = getSelectedOptions();

      return product.variants.find((variant) => {
        return variant.options.every((optionValue, index) => {
          if (!selectedOptions[index]) return true;
          return selectedOptions[index] === optionValue;
        });
      }) || null;
    }

    function getDisplayValue(variant) {
  if (!variant) return '';

  if (hasAmount && amountIndex !== null) {
    return variant.options[amountIndex] || '';
  }

  if (hasSize && sizeIndex !== null) {
    const sizeValue = variant.options[sizeIndex] || '';
    return sizeValue ? `SIZE: ${sizeValue}` : '';
  }

  if (hasColor && colorIndex !== null) {
    return variant.options[colorIndex] || '';
  }

  return '';
}

    function updateSelectedDisplay(variant) {
  if (!selectedWrapper || !selectedText) return;

  const displayValue = getDisplayValue(variant);

  if (displayValue) {
    selectedWrapper.classList.remove('is-hidden');
    selectedText.textContent = displayValue;
  } else {
    selectedWrapper.classList.add('is-hidden');
  }

  if (dotEl) {
    dotEl.style.backgroundColor = 'transparent';
  }
}

    function updateVariantUI() {
      const variant = findVariant();

      if (!variant) {
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Unavailable';
        }
        return;
      }

      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }

      if (priceText && typeof variant.price === 'number') {
        priceText.textContent = formatMoney(variant.price);
      }

      updateSelectedDisplay(variant);

      if (submitButton) {
        submitButton.disabled = !variant.available;
        submitButton.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    }

    productRoot.querySelectorAll('[data-kilo-option-input]').forEach((input) => {
      input.addEventListener('change', updateVariantUI);
    });

    toggleButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const panelName = button.dataset.kiloToggle;
        const panel = productRoot.querySelector(`[data-kilo-panel="${panelName}"]`);
        if (!panel) return;

        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isExpanded));
        panel.hidden = isExpanded;
      });
    });

    updateVariantUI();
  });
});
